/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ListIcon from '@material-ui/icons/List'
import { IHSFieldGroup } from '../../../models/HSFields'
import HSField, { fieldIsVisible } from './HSField'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../../OneplaceLibraryProvider'
import { ISelectionLists } from '../../form_controls/types'
import { IHelpInfo } from '../../../models/CustomFields'
import { HazardAutoComplete } from '../../form_controls/HazardAutoComplete'

export interface IHSFieldGroupProps extends IOneplaceLibraryContextProp {
  group: IHSFieldGroup
  selectionLists: ISelectionLists
  values: { [fieldName: string]: any }
  helpInfos: IHelpInfo[]
  onFieldsChanged(values: { [fieldName: string]: any }): void
  isOffline: boolean
}

const HSFieldGroup = withOneplaceLibraryContext((props: IHSFieldGroupProps) => {
  const visibleField = props.group.fields.find((field) =>
    fieldIsVisible(field, props.values)
  )
  if (!visibleField) {
    return null
  }

  const hazard = props.values?.hazard

  return (
    <Grid
      container
      spacing={2}
      key={props.group.label}
      style={{ marginBottom: 16 }}
    >
      <Grid item xs={12}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {props.ctx.i18next.t('customLabel_incident') === props.group.label ? (
            <>
              <ListIcon style={{ fontSize: '32px', marginRight: '5px' }} />
              <Typography variant='h5'>Details</Typography>
            </>
          ) : (
            <Typography variant='h5'>{props.group.label}</Typography>
          )}
        </div>
      </Grid>
      {props.group.fields.map((field) => (
        <React.Fragment key={field.name}>
          {field.name === 'hazard' &&
          (!field.visiField || props.values[field.visiField]) ? (
            <HazardAutoComplete
              initialSelection={hazard}
              selectionLists={props.selectionLists?.['hazardsList']}
              handleHazardChange={(_e, newHazard) => {
                props.onFieldsChanged({
                  ...props.values,
                  hazard: newHazard || null
                })
              }}
              isOffline={props.isOffline}
            />
          ) : (
            <HSField
              field={field}
              selectionLists={props.selectionLists}
              values={props.values}
              helpInfos={props.helpInfos}
              onFieldsChanged={props.onFieldsChanged}
              addSpacing={field.type === 'TEXT_AREA'}
            />
          )}
        </React.Fragment>
      ))}
    </Grid>
  )
})

export default HSFieldGroup
